export default `
  mutation toggleCardReaction($workflowId: String!, $input: CardReactionInput) {
    toggleCardReaction(workflowId: $workflowId, input: $input) {
      workflowId
      cardId
      direction
      user {
        id
        firstname
        lastname
      }
    }
  }
`
